export default __webpack_public_path__ + "static/media/myjourney-greentree-nutflower.ff54e2a4.svg";